import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import { OnTarget, Thousands } from 'Elements/Formats';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';

const Row = styled(GridRow)`
  grid-template-columns: minmax(150px, 1fr) 150px 100px 100px 50px;
`;
type Props = {
  data: Array<any>;
};

export default function SurfaceReportTable({ data }: Props) {
  return (
    <GridTable>
      <Header>
        <Row>
          <Column>Rengas</Column>
          <Column>Ura</Column>
          <Column>Akseli</Column>
          <Column>Ajettu km</Column>
          <Column />
        </Row>
      </Header>

      <Body>
        {data.map((row, index) => (
          <Row key={index}>
            <Column>
              <Grid container spacing={1} direction="column">
                <Grid item>{row.product}</Grid>
                <Grid item>
                  <Typography variant="subtitle1">{row.customer}</Typography>
                </Grid>
              </Grid>
            </Column>
            <Column>{+row.track_depth} mm</Column>
            <Column>{row.axle}</Column>
            <Column>
              <Thousands>{row.kilometers}</Thousands>
            </Column>
            <Column>
              <OnTarget
                value={row.detrition_median_diff_percentage}
                finished={row.finished != null}
              />
            </Column>
          </Row>
        ))}
      </Body>
    </GridTable>
  );
}
